import { AxiosError } from 'axios';
import { string } from 'prop-types';
import { ActionType, createAsyncAction } from 'typesafe-actions';

const SEND_FORID_REQUEST = 'find/SEND_FORID_REQUEST';
const SEND_FORID_SUCCESS = 'find/SEND_FORID_SUCCESS';
const SEND_FORID_FAILURE = 'find/SEND_FORID_FAILURE';

const FIND_USERID_REQUEST = 'find/FIND_USERID_REQUEST';
const FIND_USERID_SUCCESS = 'find/FIND_USERID_SUCCESS';
const FIND_USERID_FAILURE = 'find/FIND_USERID_FAILURE';

const SEND_FORPW_REQUEST = 'find/SEND_FORPW_REQUEST';
const SEND_FORPW_SUCCESS = 'find/SEND_FORPW_SUCCESS';
const SEND_FORPW_FAILURE = 'find/SEND_FORPW_FAILURE';

const UPDATE_USERPW_REQUEST = 'find/UPDATE_USERPW_REQUEST'
const UPDATE_USERPW_SUCCESS = 'find/UPDATE_USERPW_SUCCESS'
const UPDATE_USERPW_FAILURE = 'find/UPDATE_USERPW_FAILURE'

export const sendForIdAction = createAsyncAction(
  SEND_FORID_REQUEST,
  SEND_FORID_SUCCESS,
  SEND_FORID_FAILURE
)<{memberName: string, hpno: string}, string, AxiosError>();

export const findUserIdAction = createAsyncAction(
  FIND_USERID_REQUEST,
  FIND_USERID_SUCCESS,
  FIND_USERID_FAILURE
)<{memberName: string, hpno: string}, string, AxiosError>();

export const sendForPwAction = createAsyncAction(
  SEND_FORPW_REQUEST,
  SEND_FORPW_SUCCESS,
  SEND_FORPW_FAILURE
)<{userId: string, hpno: string}, string, AxiosError>();

export const updatePwAction = createAsyncAction(
  UPDATE_USERPW_REQUEST,
  UPDATE_USERPW_SUCCESS,
  UPDATE_USERPW_FAILURE
)<{userId: string, hpno: string, newPw: string}, string, AxiosError>();

const actions = {
  sendForIdAction,
  findUserIdAction,
  sendForPwAction,
  updatePwAction
};

export type FindAction = ActionType<typeof actions>;
